import React, { useContext, useState } from "react";
import MainHeader from "../components/MainHeader";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom"; // Assurez-vous que c'est react-router-dom
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useAxiosRequests from "../hooks/useAxiosRequest";
import ExternalRoutes from "../config/ExternalRoutes";
import { MessageContext } from "../context/MessageContext";
import AuthContext from "../context/AuthContext";
import { CircularProgress } from "@mui/material";

export const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { showSuccess, showError } = useContext(MessageContext);
  const { userInfo, updateUserInfo } = useContext(AuthContext);
  const { sendRequest } = useAxiosRequests();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

    const validationSchema = Yup.object().shape({
        currentPassword: userInfo.passwordSetted
            ? Yup.string().required("Le mot de passe actuel est requis")
            : Yup.string().notRequired(),
        newPassword: Yup.string()
            .min(8, "Le mot de passe doit contenir au moins 8 caractères")
            .required("Le nouveau mot de passe est requis"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("newPassword"), null], "Les mots de passe ne correspondent pas")
            .required("La confirmation du mot de passe est requise"),
    });


    const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  

  const onHandleSubmit = async (values, { setFieldError }) => {
    setLoading(true);
    try {
      const response = await sendRequest({
        method: "POST",
        url: ExternalRoutes.userInformation.editPassword,
        body: values
      });

        if (response.status === 'success' ) {
            updateUserInfo(response.data);
            showSuccess(response.message || "Les modifications ont été enregistrées avec succès.");

            Promise.resolve().then(() => {
              navigate("/succeded-change-password");
            });
            
        }else{
            setFieldError("currentPassword", response.message);
        }
    } catch (error) {
      showError(error.message || "Une erreur est survenue lors de l'enregistrement du nouveau mot de passe.");
    }finally{
    setLoading(false);
        }
  }

  return (
    <>
      <MainHeader />
      <div className="container">
        <div className="justify-content-center">
          <div className="kl-login-page">
            <h1>Changer de mot de passe</h1>
            <span>Définissez votre nouveau mot de passe afin de pouvoir vous connecter et accéder à Comptaride</span>
          </div>
          <div className="kl-form-login">
            <Formik
              initialValues={{
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
              }}
              validationSchema={validationSchema}
              onSubmit={onHandleSubmit}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
                isValid,
                isSubmitting,
                setFieldError
              }) => (
                <Form noValidate autoComplete="off" className="kl-form-content" onSubmit={handleSubmit}>
                    { userInfo.passwordSetted === true && (
                        <>
                  <Form.Label>Mot de passe actuel</Form.Label>
                  <div className="mb-4">
                  <div className="kl-input-container">
                    <div className="kl-fa-icon">
                       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 8.45817C14.9699 8.45817 14.9386 8.44589 14.9129 8.42024C14.8873 8.3946 14.875 8.36332 14.875 8.33317V6.6665C14.875 5.33147 14.6924 4.08231 13.9337 3.17407C13.1579 2.24534 11.8854 1.7915 10 1.7915C8.11455 1.7915 6.84211 2.24534 6.06627 3.17407C5.30756 4.08231 5.125 5.33147 5.125 6.6665V8.33317C5.125 8.36332 5.11272 8.3946 5.08707 8.42024C5.06143 8.44589 5.03015 8.45817 5 8.45817C4.96985 8.45817 4.93857 8.44589 4.91293 8.42024C4.88728 8.3946 4.875 8.36332 4.875 8.33317V6.6665C4.875 5.47939 5.02312 4.2068 5.70595 3.23526C6.36327 2.30001 7.59282 1.5415 10 1.5415C12.4072 1.5415 13.6367 2.30001 14.2941 3.23526C14.9769 4.2068 15.125 5.47939 15.125 6.6665V8.33317C15.125 8.36332 15.1127 8.3946 15.0871 8.42024C15.0614 8.44589 15.0301 8.45817 15 8.45817Z" fill="#292D32" stroke="#9CA3AF" />
                        <path d="M10.0003 15.5417C8.7848 15.5417 7.79199 14.5489 7.79199 13.3333C7.79199 12.1178 8.7848 11.125 10.0003 11.125C11.2158 11.125 12.2087 12.1178 12.2087 13.3333C12.2087 14.5489 11.2158 15.5417 10.0003 15.5417ZM10.0003 11.375C8.92418 11.375 8.04199 12.2572 8.04199 13.3333C8.04199 14.4095 8.92418 15.2917 10.0003 15.2917C11.0765 15.2917 11.9587 14.4095 11.9587 13.3333C11.9587 12.2572 11.0765 11.375 10.0003 11.375Z" fill="#292D32" stroke="#9CA3AF" />
                        <path d="M14.167 18.4585H5.83366C4.01338 18.4585 2.9997 18.1737 2.41325 17.5872C1.82681 17.0008 1.54199 15.9871 1.54199 14.1668V12.5002C1.54199 10.6799 1.82681 9.66621 2.41325 9.07976C2.9997 8.49331 4.01338 8.2085 5.83366 8.2085H14.167C15.9873 8.2085 17.001 8.49331 17.5874 9.07976C18.1738 9.66621 18.4587 10.6799 18.4587 12.5002V14.1668C18.4587 15.9871 18.1738 17.0008 17.5874 17.5872C17.001 18.1737 15.9873 18.4585 14.167 18.4585ZM5.83366 8.4585C5.079 8.4585 4.44259 8.49365 3.91841 8.6043C3.38865 8.71613 2.93759 8.91237 2.59016 9.26051C2.24279 9.60859 2.04756 10.0599 1.93651 10.589C1.82661 11.1126 1.79199 11.7478 1.79199 12.5002V14.1668C1.79199 14.9192 1.82661 15.5544 1.93651 16.078C2.04756 16.6071 2.24279 17.0584 2.59016 17.4065C2.93759 17.7546 3.38865 17.9509 3.91841 18.0627C4.44259 18.1733 5.079 18.2085 5.83366 18.2085H14.167C14.9217 18.2085 15.5581 18.1733 16.0822 18.0627C16.612 17.9509 17.0631 17.7546 17.4105 17.4065C17.7579 17.0584 17.9531 16.6071 18.0641 16.078C18.174 15.5544 18.2087 14.9192 18.2087 14.1668V12.5002C18.2087 11.7478 18.174 11.1126 18.0641 10.589C17.9531 10.0599 17.7579 9.60859 17.4105 9.26051C17.0631 8.91237 16.612 8.71613 16.0822 8.6043C15.5581 8.49365 14.9217 8.4585 14.167 8.4585H5.83366Z" fill="#292D32" stroke="#9CA3AF" />
                      </svg>
                    </div>
                    <Field
                      as={Form.Control}
                      type={showPassword ? "text" : "password"}
                      name="currentPassword"
                      className={`kl-input-login ${
                        touched.currentPassword && errors.currentPassword ? "is-invalid" : ""
                      }`}
                      placeholder="Mot de passe actuel"
                      size="lg"
                      onBlur={handleBlur} 
                    />
                    <FontAwesomeIcon
                      icon={showPassword ? faEye : faEyeSlash}
                      className="kl-eye-icon-password"
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                  <ErrorMessage
                    name="currentPassword"
                    component="small"
                    className="text-danger d-block"
                  />
                  </div>
                          </>
                        )}

                  <Form.Label>Nouveau mot de passe</Form.Label>
                  <div className="mb-4">
                  <div className="kl-input-container">
                    <div className="kl-fa-icon">
                       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 8.45817C14.9699 8.45817 14.9386 8.44589 14.9129 8.42024C14.8873 8.3946 14.875 8.36332 14.875 8.33317V6.6665C14.875 5.33147 14.6924 4.08231 13.9337 3.17407C13.1579 2.24534 11.8854 1.7915 10 1.7915C8.11455 1.7915 6.84211 2.24534 6.06627 3.17407C5.30756 4.08231 5.125 5.33147 5.125 6.6665V8.33317C5.125 8.36332 5.11272 8.3946 5.08707 8.42024C5.06143 8.44589 5.03015 8.45817 5 8.45817C4.96985 8.45817 4.93857 8.44589 4.91293 8.42024C4.88728 8.3946 4.875 8.36332 4.875 8.33317V6.6665C4.875 5.47939 5.02312 4.2068 5.70595 3.23526C6.36327 2.30001 7.59282 1.5415 10 1.5415C12.4072 1.5415 13.6367 2.30001 14.2941 3.23526C14.9769 4.2068 15.125 5.47939 15.125 6.6665V8.33317C15.125 8.36332 15.1127 8.3946 15.0871 8.42024C15.0614 8.44589 15.0301 8.45817 15 8.45817Z" fill="#292D32" stroke="#9CA3AF" />
                        <path d="M10.0003 15.5417C8.7848 15.5417 7.79199 14.5489 7.79199 13.3333C7.79199 12.1178 8.7848 11.125 10.0003 11.125C11.2158 11.125 12.2087 12.1178 12.2087 13.3333C12.2087 14.5489 11.2158 15.5417 10.0003 15.5417ZM10.0003 11.375C8.92418 11.375 8.04199 12.2572 8.04199 13.3333C8.04199 14.4095 8.92418 15.2917 10.0003 15.2917C11.0765 15.2917 11.9587 14.4095 11.9587 13.3333C11.9587 12.2572 11.0765 11.375 10.0003 11.375Z" fill="#292D32" stroke="#9CA3AF" />
                        <path d="M14.167 18.4585H5.83366C4.01338 18.4585 2.9997 18.1737 2.41325 17.5872C1.82681 17.0008 1.54199 15.9871 1.54199 14.1668V12.5002C1.54199 10.6799 1.82681 9.66621 2.41325 9.07976C2.9997 8.49331 4.01338 8.2085 5.83366 8.2085H14.167C15.9873 8.2085 17.001 8.49331 17.5874 9.07976C18.1738 9.66621 18.4587 10.6799 18.4587 12.5002V14.1668C18.4587 15.9871 18.1738 17.0008 17.5874 17.5872C17.001 18.1737 15.9873 18.4585 14.167 18.4585ZM5.83366 8.4585C5.079 8.4585 4.44259 8.49365 3.91841 8.6043C3.38865 8.71613 2.93759 8.91237 2.59016 9.26051C2.24279 9.60859 2.04756 10.0599 1.93651 10.589C1.82661 11.1126 1.79199 11.7478 1.79199 12.5002V14.1668C1.79199 14.9192 1.82661 15.5544 1.93651 16.078C2.04756 16.6071 2.24279 17.0584 2.59016 17.4065C2.93759 17.7546 3.38865 17.9509 3.91841 18.0627C4.44259 18.1733 5.079 18.2085 5.83366 18.2085H14.167C14.9217 18.2085 15.5581 18.1733 16.0822 18.0627C16.612 17.9509 17.0631 17.7546 17.4105 17.4065C17.7579 17.0584 17.9531 16.6071 18.0641 16.078C18.174 15.5544 18.2087 14.9192 18.2087 14.1668V12.5002C18.2087 11.7478 18.174 11.1126 18.0641 10.589C17.9531 10.0599 17.7579 9.60859 17.4105 9.26051C17.0631 8.91237 16.612 8.71613 16.0822 8.6043C15.5581 8.49365 14.9217 8.4585 14.167 8.4585H5.83366Z" fill="#292D32" stroke="#9CA3AF" />
                      </svg>
                    </div>
                    <Field
                      as={Form.Control}
                      type={showPassword ? "text" : "password"}
                      name="newPassword"
                      className={`kl-input-login ${
                        touched.newPassword && errors.newPassword ? "is-invalid" : ""
                      }`}
                      placeholder="Nouveau mot de passe"
                      size="lg"
                      onBlur={handleBlur} 
                    />
                    <FontAwesomeIcon
                      icon={showPassword ? faEye : faEyeSlash}
                      className="kl-eye-icon-password"
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                  <ErrorMessage
                    name="newPassword"
                    component="small"
                    className="text-danger d-block"
                    />
                    </div>

                  <Form.Label>Retaper le mot de passe</Form.Label>
                  <div className="mb-4">
                  <div className="kl-input-container">
                    <div className="kl-fa-icon">
                       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 8.45817C14.9699 8.45817 14.9386 8.44589 14.9129 8.42024C14.8873 8.3946 14.875 8.36332 14.875 8.33317V6.6665C14.875 5.33147 14.6924 4.08231 13.9337 3.17407C13.1579 2.24534 11.8854 1.7915 10 1.7915C8.11455 1.7915 6.84211 2.24534 6.06627 3.17407C5.30756 4.08231 5.125 5.33147 5.125 6.6665V8.33317C5.125 8.36332 5.11272 8.3946 5.08707 8.42024C5.06143 8.44589 5.03015 8.45817 5 8.45817C4.96985 8.45817 4.93857 8.44589 4.91293 8.42024C4.88728 8.3946 4.875 8.36332 4.875 8.33317V6.6665C4.875 5.47939 5.02312 4.2068 5.70595 3.23526C6.36327 2.30001 7.59282 1.5415 10 1.5415C12.4072 1.5415 13.6367 2.30001 14.2941 3.23526C14.9769 4.2068 15.125 5.47939 15.125 6.6665V8.33317C15.125 8.36332 15.1127 8.3946 15.0871 8.42024C15.0614 8.44589 15.0301 8.45817 15 8.45817Z" fill="#292D32" stroke="#9CA3AF" />
                        <path d="M10.0003 15.5417C8.7848 15.5417 7.79199 14.5489 7.79199 13.3333C7.79199 12.1178 8.7848 11.125 10.0003 11.125C11.2158 11.125 12.2087 12.1178 12.2087 13.3333C12.2087 14.5489 11.2158 15.5417 10.0003 15.5417ZM10.0003 11.375C8.92418 11.375 8.04199 12.2572 8.04199 13.3333C8.04199 14.4095 8.92418 15.2917 10.0003 15.2917C11.0765 15.2917 11.9587 14.4095 11.9587 13.3333C11.9587 12.2572 11.0765 11.375 10.0003 11.375Z" fill="#292D32" stroke="#9CA3AF" />
                        <path d="M14.167 18.4585H5.83366C4.01338 18.4585 2.9997 18.1737 2.41325 17.5872C1.82681 17.0008 1.54199 15.9871 1.54199 14.1668V12.5002C1.54199 10.6799 1.82681 9.66621 2.41325 9.07976C2.9997 8.49331 4.01338 8.2085 5.83366 8.2085H14.167C15.9873 8.2085 17.001 8.49331 17.5874 9.07976C18.1738 9.66621 18.4587 10.6799 18.4587 12.5002V14.1668C18.4587 15.9871 18.1738 17.0008 17.5874 17.5872C17.001 18.1737 15.9873 18.4585 14.167 18.4585ZM5.83366 8.4585C5.079 8.4585 4.44259 8.49365 3.91841 8.6043C3.38865 8.71613 2.93759 8.91237 2.59016 9.26051C2.24279 9.60859 2.04756 10.0599 1.93651 10.589C1.82661 11.1126 1.79199 11.7478 1.79199 12.5002V14.1668C1.79199 14.9192 1.82661 15.5544 1.93651 16.078C2.04756 16.6071 2.24279 17.0584 2.59016 17.4065C2.93759 17.7546 3.38865 17.9509 3.91841 18.0627C4.44259 18.1733 5.079 18.2085 5.83366 18.2085H14.167C14.9217 18.2085 15.5581 18.1733 16.0822 18.0627C16.612 17.9509 17.0631 17.7546 17.4105 17.4065C17.7579 17.0584 17.9531 16.6071 18.0641 16.078C18.174 15.5544 18.2087 14.9192 18.2087 14.1668V12.5002C18.2087 11.7478 18.174 11.1126 18.0641 10.589C17.9531 10.0599 17.7579 9.60859 17.4105 9.26051C17.0631 8.91237 16.612 8.71613 16.0822 8.6043C15.5581 8.49365 14.9217 8.4585 14.167 8.4585H5.83366Z" fill="#292D32" stroke="#9CA3AF" />
                      </svg>
                    </div>
                    <Field
                      as={Form.Control}
                      type={showPassword ? "text" : "password"}
                      name="confirmPassword"
                      className={`kl-input-login ${
                        touched.confirmPassword && errors.confirmPassword ? "is-invalid" : ""
                      }`}
                      placeholder="Confirmez le mot de passe"
                      size="lg"
                      onBlur={handleBlur} 
                    />
                    <FontAwesomeIcon
                      icon={showPassword ? faEye : faEyeSlash}
                      className="kl-eye-icon-password"
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                  <ErrorMessage
                    name="confirmPassword"
                    component="small"
                    className="text-danger d-block"
                    />
                  </div>

                  <div className="kl-reset-password text-end">
                    <NavLink to="/forgot-password">Mot de passe oublié?</NavLink>
                  </div>

                  <div className="kl-button-submit">
                    <Button
                      type="submit"
                      variant={isValid ? "primary" : "secondary"}
                      size="lg"
                      disabled={!isValid || loading}
                    >
                    {
                      loading ? 
                      <>
                                              <CircularProgress size={15} color="inherit" />
                      <span className="mx-2">Valider</span>
                        
                      </>:
                      "Valider"
                    }
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};